module.exports = __webpack_public_path__ + "static/credit_card_payment_icon-fd18ea051958127aafc3d4f293a0597c.png";